import React from 'react';
import { useNavigate } from 'react-router-dom';


import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { StyledEngineProvider } from '@mui/material';

import BlueButton from './BlueButton';

import '../css/Choice.scss';

export default function Choice({title, description, image}) {
    const navigate = useNavigate();

    const goToGame = () => {
        navigate(`/table`, {
            state:{
                game: title.toLowerCase()
            }
        });
    }
    
    return (
        <StyledEngineProvider injectFirst>
            <Card sx={{ maxWidth: 300 }} className="game-choice-card">
                <CardMedia
                    component="img"
                    height="170"
                    image={image}
                    alt=""
                    className='game-choice-img'
                />
                <CardContent className='game-choice-content'>
                    <Typography className="title" gutterBottom variant="h5" component="div">
                        {title}
                    </Typography>
                    <Typography gutterBottom className="game-description">
                        {description}
                    </Typography>
                    <Typography className='bet' gutterBottom variant="p" component="div">
                        100 minimum bet
                    </Typography>
                    <CardActions>
                        <BlueButton content="Play Now" type="game-choice" action={goToGame} />
                    </CardActions>
                </CardContent>
            </Card>
        </StyledEngineProvider>
    )
}